import { render, staticRenderFns } from "./salePerPrice.vue?vue&type=template&id=204dab95"
import script from "./salePerPrice.vue?vue&type=script&lang=js"
export * from "./salePerPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports